import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { useState } from "react";
import { SettingsMyAccount } from "./Settings/MyAccount";
import StreamerMode from "./Settings/StreamerMode";
import VoiceSettings from "./Settings/VoiceSettings";
import SettingsCustomBg from "./Settings/CustomBackground";

export const UserSettings = ({ children, user, socket }: { children: React.ReactNode, user: any, socket: any }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('myaccount');

    const isActive = (option: string) => {
        return option === selectedOption ? 'bg-brand-profile'
            : 'bg-brand-dark';
    }

    const logout = async () => {
        await fetch('__SITE_BASE__/api/logout',{method: 'POST'});
        window.location.href = '/';
    }

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>
                {children}
            </DialogTrigger>
            <DialogContent className="min-w-full w-96 rounded-none bg-brand-back border-none sm:rounded-none sm:h-screen sm:max-w-4xl flex flex-col sm:flex-row p-0 overflow-auto">
                <div className="px-4 py-6 bg-brand-dark w-full sm:w-1/4 sm:px-8 overflow-auto" style={{ scrollbarWidth: "none" }}>
                    <div className="flex flex-col items-start w-full h-full sm:h-screen p-4 font-semibold overflow-auto">
                    <div className="flex flex-col items-center justify-center text-gray-300 rounded-full">
                            <span className="text-sm">User Settings</span>
                        </div>
                        <div className="w-full mt-4 items-start justify-between space-y-2 flex flex-col">
                            <button
                                onClick={() => {
                                    setSelectedOption('myaccount');
                                }}
                                className={`text-gray-200 hover:bg-brand-darkest text-left px-2 rounded-lg py-2 hover:text-white w-full ${isActive('myaccount')}`}
                            >
                                My Account
                            </button>
                        </div>
                        <div className="flex flex-col mt-4 items-center justify-center text-gray-400 rounded-full">
                            <span className="text-sm">App Settings</span>
                        </div>
                        <div className="w-full mt-4 items-start justify-between space-y-2 flex flex-col">
                            <button
                                onClick={() => {
                                    setSelectedOption('voice');
                                }}
                                className={`text-gray-200 hover:bg-brand-darkest text-left px-2 rounded-lg py-2 hover:text-white w-full ${isActive('voice')}`}
                            >
                                Voice Settings
                            </button>
                            <button
                                onClick={() => {
                                    setSelectedOption('streamermode');
                                }}
                                className={`text-gray-200 hover:bg-brand-darkest text-left px-2 rounded-lg py-2 hover:text-white w-full ${isActive('streamermode')}`}
                            >
                                Streamer Mode
                            </button>
                            <button
                                onClick={() => {
                                    setSelectedOption('customBg');
                                }}
                                className={`text-gray-200 hover:bg-brand-darkest text-left px-2 rounded-lg py-2 hover:text-white w-full ${isActive('customBg')}`}
                            >
                                Custom Background
                            </button>
                            <hr className="border-gray-600 w-full my-2" />
                            <button
                                onClick={logout}
                                className={`text-red-200 hover:bg-brand-darkest text-left px-2 rounded-lg py-2 hover:text-red-500 transition-all w-full ${isActive('privacy')}`}
                            >
                                Log Out
                            </button>
                        </div>
                        <div className="flex gap-2 mt-4 text-xs justify-center text-gray-400 rounded-full">
                            <p>
                                __GIT_HASH__ 
                            </p>
                            <p>
                                /
                            </p>
                            <p>
                                __GIT_BRANCH__
                            </p>
                        </div>
                        
                        <div className="flex gap-2 mt-4 text-xs justify-center text-gray-400 rounded-full">
                            <p>
                               v__APP_VERSION__
                            </p>
                        </div>

                    </div>
                </div>
                <div className="w-full sm:w-3/4 p-4 py-12 sm:overflow-hidden max-h-96 sm:max-h-full overflow-auto">
                    <DialogHeader>
                        <DialogTitle>
                            {selectedOption === 'myaccount' && 'My Account'}
                            {selectedOption === 'streamermode' && 'Streamer Mode'}
                            {selectedOption === 'privacy' && 'Privacy & Safety'}
                            {selectedOption === 'voice' && 'Voice & Video'}
                            {selectedOption === 'customBg' && 'Custom Background'}
                        </DialogTitle>
                        <DialogDescription>
                        </DialogDescription>
                    </DialogHeader>
                    <div>
                        {selectedOption === 'myaccount' && user && (
                            <SettingsMyAccount user={user} />
                        ) || selectedOption === 'streamermode' && (
                            <StreamerMode />
                        ) || selectedOption === "voice" && (
                            <VoiceSettings /> 
                        ) || selectedOption === "customBg" && (
                            <SettingsCustomBg />
                        )}
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
